import map from 'lodash/map';

export default function useErrorHandling() {
  const getError = (error) => {
    if (error.response?.data?.data) {
      if (
        error.response.data.data.message
        && error.response.data.data.status !== 'fail'
      ) {
        return error.response.data.data.message;
      }

      if (error.response.data.status === 'fail') {
        return map(error.response.data.data, (item) => item[0]);
      }
    } else if (error.message) {
      return error.message;
    }

    return error;
  };

  return {
    getError,
  };
}
